import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

function WilayahRow({ w, selected, billing, onSaved }) {
  const [sel, setSel] = useState(selected);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => setSel(selected), [selected]);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/network/wilayah-map/${w.id}`, { billing_wilayah_ids: sel });
      toast.success(`Pemetaan ${w.label} tersimpan`);
      onSaved();
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  const shown = billing.filter((b) => sel.includes(b.wilayah_id) || (q && b.nama_wilayah.toLowerCase().includes(q.toLowerCase()))).slice(0, 40);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  return (
    <div className="rounded border border-[#E5E7EB] p-3" data-testid={`wmap-row-${w.code}`}>
      <div className="mb-2 flex items-center justify-between">
        <b>{w.label}</b>
        <Button size="sm" disabled={busy} onClick={save} data-testid={`wmap-save-${w.code}`}>Simpan</Button>
      </div>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari wilayah billing…" className="h-8 text-xs" data-testid={`wmap-search-${w.code}`} />
      <div className="mt-2 flex flex-wrap gap-1.5">
        {shown.map((b) => (
          <button type="button" key={b.wilayah_id} onClick={() => toggle(b.wilayah_id)} data-testid={`wmap-opt-${w.code}-${b.wilayah_id}`}
                  className={`rounded-full border px-2 py-0.5 text-xs ${sel.includes(b.wilayah_id) ? "border-[#0055FF] bg-[#EFF6FF] text-[#0055FF]" : "border-[#E5E7EB]"}`}>
            {b.nama_wilayah}
          </button>
        ))}
        {!sel.length && !q && <span className="text-xs text-[#B45309]">Belum dipetakan — Koordinator belum bisa menempatkan pelanggan.</span>}
      </div>
    </div>
  );
}

export function WilayahMapDialog({ open, refs, onClose }) {
  const [data, setData] = useState(null);
  const load = () => api.get("/network/wilayah-map").then((r) => setData(r.data));
  useEffect(() => { if (open) load(); }, [open]);
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="wmap-dialog">
        <DialogHeader>
          <DialogTitle>Pemetaan Wilayah</DialogTitle>
          <DialogDescription>Hubungkan wilayah operasional (kewenangan Koordinator untuk penempatan pelanggan pada ODP) dengan wilayah pelanggan di Billing.
            Penempatan pelanggan hanya diizinkan bila wilayah pelanggan termasuk pemetaan wilayah ODP.</DialogDescription>
        </DialogHeader>
        {!data ? <p className="text-sm">Memuat…</p> : (
          <div className="space-y-2">
            {!(refs?.master_wilayah || []).length && <p className="rounded bg-[#FFFBEB] p-2 text-xs text-[#B45309]" data-testid="wmap-no-master">
              Belum ada Master Wilayah operasional (master_wilayah) di aplikasi ini, sehingga pemetaan dan kewenangan penempatan pelanggan oleh Koordinator belum dapat diatur.</p>}
            {(refs?.master_wilayah || []).map((w) => (
              <WilayahRow key={w.id} w={w} selected={data.map[w.id] || []} billing={data.billing_wilayah} onSaved={load} />
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
